<template>
    <a v-if="employer" :href="employer.link" class="teaser-link-block small-teaser employerLink">
        <div class="horizontal-devider-line bottom-space-xs"></div>
        <div class="teaser-image-wrapper">
            <button class="button addToFavourites" @click.prevent="() => toggleFavorite(employer.id)">
                <span>{{ savedEmployers.includes(employer.id) ? 'gemerkt' : 'merken' }}</span>

                <svg width="24" height="24" viewBox="0 0 24 24" :fill="savedEmployers.includes(employer.id) ? 'currentColor' : 'transparent'" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 8.40001C1.99975 6.95035 2.58239 5.56146 3.61681 4.54584C4.65124 3.53022 6.05058 2.97317 7.5 3.00001C9.21732 2.99089 10.856 3.71919 12 5.00001C13.144 3.71919 14.7827 2.99089 16.5 3.00001C17.9494 2.97317 19.3488 3.53022 20.3832 4.54584C21.4176 5.56146 22.0002 6.95035 22 8.40001C22 13.756 15.621 17.8 12 21C8.387 17.773 2 13.76 2 8.40001Z" stroke="currentColor"></path>
                </svg>
            </button>

            <img v-if="employer._embedded?.['wp:featuredmedia'] && employer._embedded['wp:featuredmedia'][0]?.media_details?.sizes?.sm" :src="employer._embedded['wp:featuredmedia'][0].media_details.sizes.sm.source_url" alt="" />
            <img v-else-if="employer._embedded?.['wp:featuredmedia'] && employer._embedded['wp:featuredmedia'][0]?.media_details?.sizes?.medium" :src="employer._embedded['wp:featuredmedia'][0].media_details.sizes.medium.source_url" alt="" />
        </div>
        <div class="image-teaser-text-wrapper">
            <div v-if="employer.acf.topline" class="basic-text stichzeile">{{ employer.acf.topline }}</div>
            <h2 class="headline s small-bottom-padding" v-html="employer.title.rendered"></h2>
            <p v-if="employer.introblock && employer.introblock.attrs && employer.introblock.attrs.data.text_whatwedo" class="basic-text padding-bottom">{{ shortenText(employer.introblock.attrs.data.text_whatwedo) }}</p>
            <div :href="employer.link" class="text-link margin-top w-inline-block">
                <div class="basic-text">Mehr erfahren</div>
            </div>
        </div>
    </a>
</template>

<script>
import { ref, onMounted } from 'vue/dist/vue.esm-bundler';

export default {
    name: 'EmployerContainer',
    props: {
        employer: {
            type: Object,
            default: () => {}
        },
    },
    setup(props) {
        const savedEmployers = ref(localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : []);

        onMounted(() => {
            window.addEventListener('watchlist', () => {
                savedEmployers.value = localStorage.getItem('savedEmployers') ? JSON.parse(localStorage.getItem('savedEmployers')) : [];
            });
        });

        const shortenText = (text) => {
            const maxLength = 200; // maximum number of characters to extract
            //trim the string to the maximum length
            const trimmedString = text.substr(0, maxLength);
            //re-trim if we are in the middle of a word
            return `${trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')))} ...`;
        };

        const toggleFavorite = (employerId) => {
            if (savedEmployers.value.includes(employerId)) {
                savedEmployers.value = savedEmployers.value.filter((item) => item !== employerId);
                localStorage.setItem('savedEmployers', JSON.stringify(savedEmployers.value));
            } else {
                savedEmployers.value = [...savedEmployers.value, employerId];
                localStorage.setItem('savedEmployers', JSON.stringify(savedEmployers.value));
            }

            window.dispatchEvent(new Event('watchlist'));
        };

        return {
            props,
            savedEmployers,
            shortenText,
            toggleFavorite
        };
    }
};
</script>

<style lang="scss" scoped>
.teaser-image-wrapper {
    position: relative;
    margin-top: 20px;
    width: 100%;

    .addToFavourites {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        position: absolute;
        top: 8px;
        right: 8px;
        padding: 8px;
        margin: 0;
        border: 0;
        background-color: var(--bayhovercolor);
        line-height: 1;
        font-size: 18px !important;
        color: #fff;

        &:hover {
            left: auto;
            background-color: var(--baytmblue);
        }

        span {
            margin-top: -2px;
        }
    }
}

.image-teaser-text-wrapper {
    width: 100%;

    @media (max-width: 991px) {
        padding-left: 0;
    }
}

a.employerLink {
    display: flex;
    flex-direction: column;
    gap: 2vw;
    min-width: 0;
    text-decoration: none;

    &:hover {
        color: #21b5ea;
    }

    div.horizontal-devider-line.bottom-space-xs {
        margin-bottom: -10px;

        @media(min-width: 992px) {
            margin-bottom: -20px;
        }
    }

    .text-link {
        color: inherit
    }
}
</style>
